export default __webpack_public_path__ + "static/media/hero-image.7f7f2332.png";